/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button, FormGroup, Label, Input, Form } from 'reactstrap'
//import { Formik, Field, FieldArray, Form } from 'formik'
import { I18n } from 'react-redux-i18n'
import { connect } from 'react-redux'
import InfoTooltip from '../../../../components/InfoTooltip'
import { company } from '../../../../api'
import Nixi1Spinner from 'components/Nixi1Spinner'
const businessModelApi = company.commissions

const BusinessManagementRow = (props) => {
  const [active, setActive] = useState('')
  const [loading, setLoading] = useState(true)
  const [commission, setCommission] = useState({})

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const getBusinessModel = () => {
    businessModelApi
      .getBusinessModel({ provider: props.id }, { company: props.companies._id })
      .then(({ data, status }) => {
        if (status === 200) setCommission(data.results)
      })
      .catch(console.error)
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (props.key && active === 'active') {
      setLoading(true)
      getBusinessModel()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.key])

  const toggleActive = () => {
    if (active) return
    setActive('active')
    getBusinessModel()
  }

  const hideActive = () => setActive('')

  const handleSubmit = (e) => {
    e.preventDefault()

    commission.ranges = commission.ranges.reduce((current, next) => {
      if (!current.length || current[current.length - 1].value !== next.value) {
        return current.concat(next)
      } else {
        return current
      }
    }, [])

    businessModelApi
      .updateBusinessModel({ ...commission, company: props.companies._id })
      .then(({ status }) => {
        if (status === 200) {
          setCommission({ ...commission })
        } else {
          throw new Error('Body not ok')
        }
      })
      .catch(console.error)
      .finally(() => hideActive())
  }

  const handleChangeRange = (index, prop, value) => {
    commission.ranges[index][prop] = value
    setCommission({ ...commission })
  }

  const handleRemoveRange = (index) => {
    commission.ranges = commission.ranges.filter((item, i) => i !== index)
    setCommission({ ...commission })
  }

  const handleAddRange = () => {
    const { ranges } = commission
    let range
    if (ranges.length) {
      const { value } = ranges[ranges.length - 1]
      range = { value, net: 0, percent: 0 }
    } else {
      range = { value: 0, net: 0, percent: 0 }
    }
    commission.ranges.push(range)
    setCommission({ ...commission })
  }

  const getInfoApi = (commission) => {
    switch (commission.key) {
      case 'api_bookingcom':
        return (
          <Container>
            <Row className='my-3 justify-content-center'>
              <Col xs={11}>{I18n.t('dashboard_booking-message-commissions')}</Col>
            </Row>
            <Row className='mb-3'>
              <Col className='text-right'>
                <Button color='primary' className='mr-3 px-2 py-1' onClick={hideActive}>
                  {I18n.t('dashboard_close')}
                </Button>
              </Col>
            </Row>
          </Container>
        )
      case 'api_intermundial':
        return (
          <Container>
            <Row className='my-3 justify-content-center'>
              <Col xs={11}>{I18n.t('dashboard_intermundial-message-commissions')}</Col>
            </Row>
            <Row className='mb-3'>
              <Col className='text-right'>
                <Button color='primary' className='mr-3 px-2 py-1' onClick={hideActive}>
                  {I18n.t('dashboard_close')}
                </Button>
              </Col>
            </Row>
          </Container>
        )
      default:
        return (
          <Form onSubmit={handleSubmit}>
            <Container>
              <Row className='my-3 justify-content-center'>
                <Col className='mb-3' xs={8}>
                  <FormGroup>
                    <Label>
                      {I18n.t('dashboard_net-commission')}
                      <InfoTooltip targetId={`business-model-${commission.key}-net`} position='right' text={I18n.t('dashboard_net-commission')} />
                    </Label>
                    <Input
                      disabled={commission.ranges.length > 0}
                      type='number'
                      min={0}
                      name='net'
                      className='form-control'
                      value={commission.net || ''}
                      onChange={({ target }) => setCommission({ ...commission, [target.name]: parseInt(target.value) })}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label>
                      {I18n.t('dashboard_percentage-commission')}
                      <InfoTooltip
                        targetId={`business-model-${commission.key}-percent`}
                        position='right'
                        text={I18n.t('dashboard_percentage-commission')}
                      />
                    </Label>
                    <Input
                      disabled={commission.ranges.length > 0}
                      type='number'
                      min={0}
                      name='percent'
                      className='form-control'
                      value={commission.percent || ''}
                      onChange={({ target }) => setCommission({ ...commission, [target.name]: parseInt(target.value) })}
                    />
                  </FormGroup>
                </Col>
                <Col className='mb-3 px-0' xs={8}>
                  <FormGroup>
                    <Row>
                      <Col>
                        <Label>{I18n.t('dashboard_commission-applied-by-range')}</Label>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={'text-center'}>
                        {I18n.t('dashboard_range-value')}
                        <InfoTooltip
                          targetId={`business-model-range-${commission.key}-value`}
                          position='right'
                          text={I18n.t('dashboard_range-value')}
                        />
                      </Col>
                      <Col className={'text-center'}>{I18n.t('dashboard_net-commission')}</Col>
                      <Col className={'text-center'}>{I18n.t('dashboard_percentage-commission')}</Col>
                      <Col className={'p-0'} xs={1} />
                    </Row>
                    {commission.ranges.map((r, i) => (
                      <div key={i} className='mb-1'>
                        <Row>
                          <Col className={'text-center'}>
                            <Input
                              name={`ranges.${i}.value`}
                              className='form-control'
                              type='number'
                              min={i === 0 ? 0 : commission.ranges[i - 1].value}
                              value={r.value}
                              onChange={({ target }) => handleChangeRange(i, 'value', parseInt(target.value))}
                            />
                          </Col>
                          <Col className={'text-center'}>
                            <Input
                              name={`ranges.${i}.net`}
                              className='form-control'
                              type='number'
                              min={0}
                              value={r.net}
                              onChange={({ target }) => handleChangeRange(i, 'net', parseInt(target.value))}
                            />
                          </Col>
                          <Col className={'text-center'}>
                            <Input
                              name={`ranges.${i}.percent`}
                              className='form-control'
                              type='number'
                              min={0}
                              value={r.percent}
                              onChange={({ target }) => handleChangeRange(i, 'percent', parseInt(target.value))}
                            />
                          </Col>
                          <Col xs={1} className={'p-0'}>
                            <span style={{ cursor: 'pointer' }} onClick={() => handleRemoveRange(i)}>
                              <i className='fa fa-times' />
                            </span>
                          </Col>
                        </Row>
                      </div>
                    ))}

                    <Row>
                      <Col xs={12} className='my-3 text-center'>
                        <Button color='default' onClick={handleAddRange} disabled={!!commission.net || !!commission.percent}>
                          {I18n.t('dashboard_add-range')}
                        </Button>
                      </Col>
                    </Row>
                  </FormGroup>
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col className='text-right'>
                  <Button color='default' className='mr-3 px-2 py-1' onClick={hideActive}>
                    {I18n.t('dashboard_cancel')}
                  </Button>
                  <Button type='submit' color='primary' className='px-2 py-1'>
                    {I18n.t('dashboard_save')}
                  </Button>
                </Col>
              </Row>
            </Container>
          </Form>
        )
    }
  }

  const { inactiveRow } = props
  return (
    <tbody onClick={toggleActive} className={active}>
      {inactiveRow}
      {active ? (
        <tr className='active-row'>
          <td colSpan={2}>
            {loading ? (
              <Nixi1Spinner width={'25px'} height={'25px'} />
            ) : (
              <div>
                {Object.keys(commission).length ? (
                  getInfoApi(commission)
                ) : (
                  <div>
                    <span>Cannot get provider data. &nbsp;</span>
                    <a
                      href='#'
                      onClick={(e) => {
                        e.preventDefault()
                        getBusinessModel()
                      }}
                    >
                      Try Again
                    </a>
                  </div>
                )}
              </div>
            )}
          </td>
        </tr>
      ) : null}
    </tbody>
  )
}

export default connect((state) => ({ companies: state.companies }))(BusinessManagementRow)
